<section class="aboutusrow">
    <div class="container">
        <div class="row">
            <div class="col-md-12 text-center">
                <div class="white_fonts">
                    <div class="row animate__animated animate__fadeInUp top" data-aos="fade-up" data-aos-delay="150">
                        <div class="col-sm-2"></div>
                        <div class="col-sm-8">
                            <header class="section-header">
                                <h3>OSHA Assistance</h3>
                            </header>
                        </div>
                        <div class="col-sm-2"></div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</section>

<section style="margin-bottom: -50px;">
    <div class="container">
        <div class="row">
            
            <div class="col-lg-8" data-aos="fade-left" data-aos-delay="100" style="padding-top: 20px;">
                <h3 class="theme_color">
                    <strong>OSHA Inspection Assistance</strong>
                </h3>

                <p class="theme_color fontSize">If OSHA visits your workplace or jobsite, 
                    SFI Safety can assist you throughout the inspection process. 
                    Our experienced safety consultants help you prepare documentation,
                     communicate your existing safety efforts, and demonstrate the proactive steps your 
                     organization has taken to protect employees and address hazards.</p>

                <p class="theme_color fontSize">
                    Our role is to help you navigate the process with confidence while ensuring OSHA has a clear understanding 
                    of your safety program, training, inspections,
                    corrective actions, and other efforts already in place.
                </p>
            </div>
            <div class="col-lg-4" data-aos="fade-right" data-aos-delay="100">
                <img src="../../assets/images/osha2.jpeg" class="img-fluid" alt="" /><br />                
            </div>
            <div class="col-lg-12"  data-aos-delay="100">
                  <p><strong>Support After the Inspection</strong></p>
                  <p class="theme_color fontSize">
                    Our assistance does not end when the OSHA inspection is complete. If citations are issued, 
                    SFI Safety can help you understand the findings, identify appropriate
                     corrective actions, organize supporting documentation, and complete required abatement certification.
                </p>
                <p class="theme_color fontSize">
                    OSHA generally requires employers to certify that cited hazards have been corrected,
                    except for items specifically identified as corrected during the inspection. 
                    Certain violations may also require supporting abatement documentation showing how the hazard was corrected.
                </p>
                <p class="theme_color fontSize">
                    Our safety consultants can help guide you through each step, including reviewing the citation, 
                    developing corrective actions,
                     documenting completion, and helping ensure required information is submitted appropriately.
                </p>
            </div>
            <div class="col-lg-12"  data-aos-delay="100">
                <p><strong>Informal Conference Assistance</strong></p>
                <p class="theme_color fontSize">
                    Employers may request an informal conference with the OSHA Area Director to discuss citations, 
                    proposed penalties, abatement dates, corrective actions, or other issues resulting from an inspection. 
                    Under Federal OSHA procedures, 
                    this generally must occur within the 15-working-day contest period following receipt of a citation.
              </p>
              <p class="theme_color fontSize">
                SFI Safety can help you prepare for and participate in the informal conference process. 
                We can organize supporting documentation, explain corrective 
                actions already taken, and help communicate the steps your organization has implemented to improve safety.
              </p>
              <p class="theme_color fontSize">
                Depending on the facts and circumstances, OSHA may modify citation classifications, abatement dates, 
                or proposed penalties as part of the informal resolution process. Any adjustment is determined by OSHA 
                and is not guaranteed.
              </p>
          </div>
          <div class="col-lg-12"  data-aos-delay="100">
            <p><strong>Be Prepared Before OSHA Arrives</strong></p>
            <p class="theme_color fontSize">
                The strongest OSHA response begins long before an inspector arrives. Regular inspections, 
                documented corrective actions, employee training, effective safety programs, 
                and consistent follow-through can help demonstrate that your organization takes workplace safety seriously.
          </p>
          <p class="theme_color fontSize">
            That is where SFI Safety’s <strong>Beyond Compliance </strong> approach provides additional value.
             We help clients build the systems, documentation, accountability, 
            and safety practices that support stronger performance every day—not just when OSHA arrives.
          </p>
          <p class="theme_color fontSize">
            <a href="/contact" class="theme_color fontRed"><u><strong>Contact us</strong></u></a> to learn more about OSHA inspection assistance, 
            citation support, abatement documentation, and informal conference preparation.
          </p>
      </div>
        </div>
    </div>
</section>

<section style="background-color: #F2F3F5;">
    <div class="container">
        <div class="row">
            <div class="col-lg-8" data-aos="fade-up" data-aos-delay="100" style="margin-top: 10px;">
                <h2 class="theme_color">
                    <strong>Abatement Certification</strong>.
                </h2>               

                <p class="theme_color fontSize">You might wonder,<b> “What is abatement
                    Certification”?</b> Abatement refers to mitigation or
                    corrective actions that have been taken to comply
                    with a cited standard or eliminate a hazardous
                    condition. Abatement certification is the signed
                    statement or affidavit that an employer sends to
                    OSHA following a citation and Abatement
                    documentation is proof of the correction. Our Safety
                    Professionals will assist you with each step and can
                    help you determine which corrective actions are
                    needed, as well as how to meet OSHA regulations
                    when implementing the corrections.</p>

                    <h2 class="theme_color">
                        <strong>Reduced Penalties</strong>.
                    </h2>               
    
                    <p class="theme_color fontSize">Through an informal conference with OSHA, alleged
                        violations, proposed penalties, and other information from the inspection may be discussed with
                        OSHA’s Assistant Regional Director. SFI Compliance can help you to navigate this process and
                        assist with negotiating on your behalf. As part of the Informal Conference, penalties may be
                        reduced or even eliminated, and SFI Compliance has a strong track record for achieving these
                        results. If you’d like to know more <a href="/contact" class="theme_color"><strong class="fontRed"><u>contact us</u></strong></a>  today!</p>

                
                <p></p>                
            </div>
            <div class="col-lg-4 order-first order-md-last" data-aos="fade-up" data-aos-delay="100"
                style="margin-top: 10px;">
                <img src="../../assets/images/osha1.jpeg" class="img-fluid" alt="" />
            </div>
        </div>
    </div>
</section>